import { app } from '../../../../app';
import { Controller } from './fido-registration.controller';

app.component('fidoRegistration', {
	bindings: {vkey: '<'},
    controller: Controller,
    templateUrl: require('./fido-registration.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/public/verification/fido-registration/fido-registration.component.js